var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.PriceChart,{staticClass:"mt-4",attrs:{"price-chart-data":_setup.priceChartData,"chart-height":_vm.chartHeight}}),_vm._v(" "),_c('LazyGalleryHistory',{staticClass:"is-hidden",attrs:{"events":_vm.nftEvents},on:{"setPriceChartData":_setup.setPriceChartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }